export default __webpack_public_path__ + "static/media/Account.0a4ca4c3.jpeg";